import React from 'react';
import MuiFormControlLabel, { FormControlLabelProps as MuiFormControlLabelProps } from '@mui/material/FormControlLabel';

export interface FormControlLabelProps extends MuiFormControlLabelProps {}

const FormControlLabel = React.forwardRef<HTMLLabelElement, FormControlLabelProps>(
  function FormControlLabel(props, ref) {
    return <MuiFormControlLabel ref={ref} {...props} />;
  }
);

export default FormControlLabel;
